export enum Region {
  AU = 'AU',
  NZ = 'NZ',
}

export const REGION_FULL_NAMES = {
  AU: 'Australia',
  NZ: 'New Zealand',
};
